import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

// import * as actions from '../actions';

import github from './assets/GitHub-Mark-Light-64px.png';
import linkedin from './assets/In-2C-48px-R.png';

class Footer extends Component {
	state = {};

	render() {
		return (
			<React.Fragment>
				<div
					className="row"
					style={{
						height: 'calc(0.27 * 100vh)',
						background: '#000',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
					}}
				>
					<div>
						<h1
							style={{
								fontSize: '4.0vh',
								textTransform: 'uppercase',
								// letterSpacing: "-2px",
								fontFamily: 'Avant Garde, Avantgarde, Century Gothic, CenturyGothic, AppleGothic, sans-serif',
								fontWeight: 'bold',
								borderBottom: '25px solid rgba(255,255,255,0.5)',
							}}
						>
							<span
								style={{
									color: 'darkorange',
									opacity: '0.5',
								}}
							>
								George
							</span>
							<span
								style={{
									color: 'white',
									opacity: '0.5',
								}}
							>
								kanchev
							</span>
						</h1>
						<h2
							style={{
								textAlign: 'center',
								fontSize: '2.7vh',
								color: 'white',
								opacity: '0.5',
								// letterSpacing: "30px",
								fontFamily: 'Avant Garde, Avantgarde, Century Gothic, CenturyGothic, AppleGothic, sans-serif',
							}}
						>
							Software Developer
						</h2>
						<div className="row d-flex justify-content-center p-1">
							<a href="https://github.com/GeorgeKanchev" target="_blank" rel="noopener noreferrer">
								<img src={github} alt="GitHub logo" width="30" height="30" className="mr-2" />{' '}
							</a>
							<a href="https://www.linkedin.com/in/georgikanchev/" target="_blank" rel="noopener noreferrer">
								<img src={linkedin} alt="Linkedin logo" width="30" height="30" />
							</a>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

export default withRouter(
	connect(
		mapStateToProps,
		null,
	)(Footer),
);



// WEBPACK FOOTER //
// ./src/components/nav/Footer.js